<div class="error-message" *ngIf="!isFormArray" [style.top.px]="top" [style.left.px]="left">{{ getError() }}</div>
<div class="error-message" *ngIf="isFormArray" [style.top.px]="top" [style.left.px]="left">{{ getFormErrors() }}</div>
